import CaptivePortalContinue from './CaptivePortalContinue';

export default CaptivePortalContinue;
